import React, { useContext } from 'react';
import { UserContext } from './userContext';
import { Switch, Route, Redirect } from "react-router-dom";
import HomePage from '../pages/home';
import UserLog from '../pages/userlog';
import ChangePassword from '../pages/changePassword';
import MoviesTable from '../pages/moviesList';
import MovieForm from '../pages/movieForm';
import GamesTable from '../pages/gamesList';
import GameForm from '../pages/gameForm';
import MoviesComponent from './movies';
import MovieDetail from '../pages/movieDetail';
import GamesComponent from './games';
import GameDetail from '../pages/gameDetail';


export default function Content() {
  const { user } = useContext(UserContext);
  const acc = user ? user.email : '';

	const PrivateRoute = ({...rest}) => {
    if (user) return <Route {...rest} />
    return <Redirect to='/user/signin' />
  }

  const LogRoutes = ({...rest}) => {
    if (user) return <Redirect to='/' />
    return <Route {...rest} />
  }

  return(
    <Switch>
      <Route exact path="/movies" component={MoviesComponent}></Route>
      <Route exact path="/movie/detail/:itemId" component={MovieDetail}></Route>
      <Route exact path="/games" component={GamesComponent}></Route>
      <Route exact path="/game/detail/:itemId" component={GameDetail}></Route>
      <LogRoutes exact path="/user/:log" component={UserLog}></LogRoutes>
      <PrivateRoute exact path={`/${acc}/dashboard/change-password`} component={ChangePassword}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/movie-editor/list`} component={MoviesTable}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/movie-editor/create`} component={MovieForm}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/movie-editor/edit/:itemId`} component={MovieForm}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/game-editor/list`} component={GamesTable}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/game-editor/create`} component={GameForm}></PrivateRoute>
      <PrivateRoute exact path={`/${acc}/dashboard/game-editor/edit/:itemId`} component={GameForm}></PrivateRoute>
      <Route exact path="/" component={HomePage}></Route>
    </Switch>
  )
}